var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bank-entries-container card-item secondary" },
    [
      _c("h5", { staticClass: "is-size-5 pb-3" }, [
        _vm._v(_vm._s(_vm.$t("transactions.bankEntriesTitle"))),
      ]),
      _c(
        "div",
        {
          staticClass: "control entry-searcher has-icons-left",
          attrs: { id: "search" },
        },
        [
          _c("b-taginput", {
            staticClass: "search-tags",
            attrs: {
              id: "search-bank-entries-input",
              icon: "search",
              rounded: "",
              ellipsis: "",
              placeholder: _vm.$t("generalWords.Search"),
              size: "is-small",
              "close-type": "is-success",
            },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
        ],
        1
      ),
      _vm.totals
        ? _c(
            "div",
            { staticClass: "validation-totals my-2" },
            [
              _c(
                "b-tag",
                { staticClass: "has-text-weight-bold", attrs: { rounded: "" } },
                [
                  _c("span", [_vm._v("Total: ")]),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.formatNumberByCountry(
                          _vm.selectedEntries.totalAmount
                        )
                      )
                    ),
                  ]),
                ]
              ),
              _c(
                "b-tag",
                {
                  staticClass: "has-text-weight-bold",
                  attrs: {
                    rounded: "",
                    type:
                      _vm.selectedEntries.totalAmount -
                        _vm.currentTransactionAmount <
                      0
                        ? "is-danger is-light"
                        : "is-primary is-light",
                  },
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("generalWords.Difference")) + ":"),
                  ]),
                  _c("span", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.formatNumberByCountry(
                            _vm.selectedEntries.totalAmount -
                              _vm.currentTransactionAmount
                          )
                        ) +
                        " "
                    ),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "section",
        { staticClass: "transfers-table" },
        _vm._l(_vm.filteredBankEntries, function (entry) {
          return _c(
            "div",
            {
              key: entry._id,
              staticClass:
                "bank-entries p-2 is-flex is-justify-content-flex-start",
            },
            [
              _vm.type === "checkbox"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.checkedEntries,
                        expression: "checkedEntries",
                      },
                    ],
                    staticClass: "mr-5",
                    attrs: {
                      id: `${_vm.idPrefix}-${entry._id}`,
                      type: "checkbox",
                    },
                    domProps: {
                      value: _vm.type === "radio" ? [entry] : entry,
                      checked: Array.isArray(_vm.checkedEntries)
                        ? _vm._i(
                            _vm.checkedEntries,
                            _vm.type === "radio" ? [entry] : entry
                          ) > -1
                        : _vm.checkedEntries,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$a = _vm.checkedEntries,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = _vm.type === "radio" ? [entry] : entry,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.checkedEntries = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.checkedEntries = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.checkedEntries = $$c
                          }
                        },
                        function ($event) {
                          return _vm.$emit("input", _vm.selectedEntries)
                        },
                      ],
                    },
                  })
                : _vm.type === "radio"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.checkedEntries,
                        expression: "checkedEntries",
                      },
                    ],
                    staticClass: "mr-5",
                    attrs: {
                      id: `${_vm.idPrefix}-${entry._id}`,
                      type: "radio",
                    },
                    domProps: {
                      value: _vm.type === "radio" ? [entry] : entry,
                      checked: _vm._q(
                        _vm.checkedEntries,
                        _vm.type === "radio" ? [entry] : entry
                      ),
                    },
                    on: {
                      change: [
                        function ($event) {
                          _vm.checkedEntries =
                            _vm.type === "radio" ? [entry] : entry
                        },
                        function ($event) {
                          return _vm.$emit("input", _vm.selectedEntries)
                        },
                      ],
                    },
                  })
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.checkedEntries,
                        expression: "checkedEntries",
                      },
                    ],
                    staticClass: "mr-5",
                    attrs: {
                      id: `${_vm.idPrefix}-${entry._id}`,
                      type: _vm.type,
                    },
                    domProps: {
                      value: _vm.type === "radio" ? [entry] : entry,
                      value: _vm.checkedEntries,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("input", _vm.selectedEntries)
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.checkedEntries = $event.target.value
                      },
                    },
                  }),
              _c("div", { staticClass: "is-flex bank-entries-rows" }, [
                _c(
                  "label",
                  {
                    staticClass: "item-amount",
                    attrs: { for: `${_vm.idPrefix}-${entry._id}` },
                  },
                  [_vm._v(_vm._s(_vm.formatNumberByCountry(entry.amount)))]
                ),
                _c(
                  "label",
                  {
                    staticClass: "item-name entity-name",
                    attrs: { for: `${_vm.idPrefix}-${entry._id}` },
                  },
                  [_vm._v(_vm._s(_vm.formatName(entry.entity.name)))]
                ),
                _c(
                  "label",
                  {
                    staticClass: "item-date",
                    attrs: { for: `${_vm.idPrefix}-${entry._id}` },
                  },
                  [_vm._v(_vm._s(_vm.formatDate(entry.date, "DD/MM/YYYY")))]
                ),
                _c(
                  "label",
                  {
                    staticClass: "item-idnumber",
                    attrs: { for: `${_vm.idPrefix}-${entry._id}` },
                  },
                  [_vm._v(_vm._s(_vm.formatRut(entry.entity.idNumber || "")))]
                ),
                _c(
                  "label",
                  {
                    staticClass: "item-bankname",
                    attrs: { for: `${_vm.idPrefix}-${entry._id}` },
                  },
                  [_vm._v(_vm._s(_vm.formatName(entry.entity.bankName)))]
                ),
              ]),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }